var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        size: "md",
        okOnly: "",
        noFade: "",
        hideHeaderClose: "",
        noCloseOnBackdrop: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function() {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "apps.settings.permission.appid" + _vm.dataModal.app_id
                    )
                  ) +
                  "\n    ->\n    " +
                  _vm._s(
                    _vm.$t(
                      "apps.settings.permission.appid" +
                        _vm.dataModal.app_id +
                        "-moduleid" +
                        _vm.dataModal.module_id
                    )
                  ) +
                  "\n    "
              ),
              _vm.dataModal.submodule_id
                ? [
                    _vm._v(
                      "\n      ->\n      " +
                        _vm._s(
                          _vm.$t(
                            "apps.settings.permission.appid" +
                              _vm.dataModal.app_id +
                              "-moduleid" +
                              _vm.dataModal.module_id +
                              "-submoduleid" +
                              _vm.dataModal.submodule_id
                          )
                        ) +
                        "\n    "
                    )
                  ]
                : _vm._e()
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c("div", { staticClass: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    on: {
                      click: function($event) {
                        return _vm.handleCancel(ok)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("button.cancel")) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web",
                    on: {
                      click: function($event) {
                        return _vm.handleSubmit(ok)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("button.apply")) + "\n      "
                    )
                  ]
                )
              ])
            ]
          }
        }
      ])
    },
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39ea8543", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ea8543","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalPermissionSetting.vue
// module id = null
// module chunks = 